import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=708fc692&scoped=true&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fc692",
  null
  
)

export default component.exports